import loadable from '@loadable/component';
import { type FunctionComponent } from 'react';
import { useInView } from 'react-intersection-observer';
import { type CommonPromoFieldsFragment } from '../../../__generated__/graphql-client-types';
import { type CategoryPageContentProps } from './category-content.component';

export type LoadableCategoryContentProps = {
	content: CategoryPageContentProps | null;
	categoryName: string;
	promo?: CommonPromoFieldsFragment;
};

const LoadedCategoryContent = loadable(() => import(/* webpackChunkName: "category-content" */ './category-content.component'), {
	resolveComponent: ({ CategoryContent }) => CategoryContent
});

export const LoadableCategoryContent: FunctionComponent<LoadableCategoryContentProps> = ({ content, categoryName, promo }) => {
	const { ref: categoryContentRef, inView: categoryContentInView } = useInView({ triggerOnce: true });

	return (
		<div ref={categoryContentRef}>
			{content && categoryContentInView && <LoadedCategoryContent categoryName={categoryName} content={content} promo={promo} />}
		</div>
	);
};
